// extracted by mini-css-extract-plugin
module.exports = {"countDown":"timer_countDown__zqe4P","time":"timer_time__1P5cA","dot":"timer_dot__2f-EX"};